export default function FeaturesSection() {
  const features = [
    {
      title: 'オーダーメイド',
      description: '岡山の熟練職人が、お客様の想いを込めて一つひとつ丁寧に制作いたします。世界に一つだけのジュエリーをお作りします。',
      image: 'https://static.readdy.ai/image/2333ec8ce0f23b8d6e87acea74053a0e/a57b23b8c3e9cf5e32ba97d02d69d193.jpeg',
    },
    {
      title: 'リメイク・修理',
      description: '祖父母や親から受け継いだ大切なジュエリーを、現代的なデザインに生まれ変わらせます。想い出を新しい形で。',
      image: 'https://public.readdy.ai/ai/img_res/8a4aaf536770c351d00dd996d67bf377.jpg',
    },
    {
      title: 'ブライダル',
      description: '結婚という人生の大切な節目に、お二人の愛を象徴する特別な指輪を。岡山で最高の結婚指輪・婚約指輪をご提案します。',
      image: 'https://readdy.ai/api/search-image?query=japanese%20couple%20hands%20exchanging%20beautiful%20wedding%20rings%20soft%20romantic%20lighting%20cream%20and%20white%20tones%20elegant%20bridal%20jewelry%20close-up%20shot%20gentle%20touch%20love%20and%20commitment%20high%20quality%20wedding%20photography%20timeless%20moment&width=800&height=600&seq=feature3&orientation=landscape',
    },
  ];

  return (
    <section className="py-20 lg:py-28 bg-cream-100">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-semibold text-center text-brown-600 mb-16">
          ジュエリーおかやまが選ばれる理由
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {features.map((feature, index) => (
            <article key={index} className="group cursor-pointer">
              <div className="relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300">
                <div className="w-full h-80">
                  <img
                    src={feature.image}
                    alt={`${feature.title} - 岡山のジュエリーおかやま`}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  />
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-brown-600/90 to-transparent p-6">
                  <h3 className="text-2xl font-serif font-semibold text-white mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-white/90 text-sm leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}